import { createContext, useContext } from "react";
import type { CurrentUser } from "@jipraks/shared";
import type { ViewMode } from "@client/lib/view-mode-storage";

export type AuthStatus = "loading" | "anonymous" | "authenticated";

export interface AuthContextValue {
  status: AuthStatus;
  user: CurrentUser | null;
  /** Always "user" for non-admins. */
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  /** Full-page navigation to Google; returns to `redirectPath` afterwards. */
  signIn: (redirectPath?: string) => void;
  signOut: () => Promise<void>;
  setUser: (user: CurrentUser) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside <AuthProvider>");
  return value;
}
